/**
 * Build-time configuration. In dev `apiBaseUrl` is empty so requests are relative and the Vite
 * dev server proxies them to the API (keeps the session cookie first-party). In a staging/prod
 * build it is the API origin (api.salonomy.com), reached cross-origin with credentials.
 */
const rawBase = import.meta.env.VITE_API_BASE_URL ?? '';

export const env = {
  /** API origin, or '' for same-origin (dev proxy). No trailing slash. */
  apiBaseUrl: rawBase.replace(/\/$/, ''),
  /** Public base for shareable queue links, e.g. https://salonomy.com. */
  queuePublicBaseUrl: (
    import.meta.env.VITE_QUEUE_PUBLIC_BASE_URL ?? 'https://salonomy.com'
  ).replace(/\/$/, ''),
  /** True when talking to the API cross-origin (prod build); drives EventSource credentials. */
  get crossOrigin(): boolean {
    return this.apiBaseUrl.length > 0;
  },
} as const;
